import { useCallback, useEffect, useState } from 'react';
import { examLibraryApi, apiErrorMessage } from '../services/api';
import { useOrg } from '../context/OrgContext';

export default function useEnrolledExams() {
  const org = useOrg();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    return examLibraryApi.enrolled(org.id)
      .then((res) => { setExams(res.data || []); setError(null); })
      .catch((err) => setError(apiErrorMessage(err, 'Failed to load enrolled exams')))
      .finally(() => setLoading(false));
  }, [org.id]);

  useEffect(() => { load(); }, [load]);

  return { exams, loading, error, reload: load };
}
